"use strict";

exports.__esModule = true;
exports.AUTOPILOT_USER_UUID = void 0;
var AUTOPILOT_USER_UUID = '6316f5bb-5858-4345-92ed-04566c1d7f54';
exports.AUTOPILOT_USER_UUID = AUTOPILOT_USER_UUID;